import React, { useMemo, useState, useEffect } from "react";
import PageName from "../../components/PageName";
import Card from "../../components/Base/Card";
import { FiChevronDown, FiDownloadCloud } from "react-icons/fi";
import BaseDateRangePicker from "../../components/Base/BaseDateRangePicker";
import BaseFilter from "../../components/Base/BaseFilter";
import { Table } from "../../components/Base/BaseTable";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { formatCurrency } from "../../utils";
import TransactionSummaryModal from "../../components/TransactionSummaryModal";
import NoTransactionImage from "../../assets/images/no-transactions.png";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getTransactionHistory } from "../../redux/transactions/transactionSlice";
import LoadingSpinner from "../../components/LoadingSpinner";
import { downloadStatement } from "../../redux/statement/statementSlice";
import {TransactionI} from "../../interfaces";
import {format, parseISO} from "date-fns";
import {Routes} from "react-router-dom";
import {RouteNames} from "../../constants";
import {CheckBenefitStatus, TrackBenefit} from "../../redux/selfService/selfServiceSlice";

const TrackBenefitPage = () => {
    const [filterValue, setFilterValue] = useState("");
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
   const { trackBenefit, isLoading, isSuccessful } = useAppSelector((state) => state?.selfService);
   const { user } = useAppSelector((state) => state?.auth);
    const dispatch = useAppDispatch();
  // Initialize isSuccess to a default value (e.g., false) outside the useEffect
  const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        if(user.pin) dispatch(TrackBenefit(user.pin));


        dispatch(CheckBenefitStatus(user?.pin)).then((res)=>{
            console.log(res);
          if(res.type === "selfService/benefitstatus/fulfilled" && res.payload !== undefined)
          {
            const isSuccess = res.payload.isSuccess;
              // Set the isSuccess variable in the component's state
          setIsSuccess(isSuccess);
          }
            

            
    // Log the response
    console.log("Response:", res);
        });
    }, [user]);

    const setDateRangeHandler = (dates: Date[]) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };



    const columns: any = useMemo(
        () => [
            {
                Header: "#",
                accessor: "id"
            },
            {
                Header: "Application Type",
                accessor: "applicationType",
            },
            {
                Header: "Application Date",
                accessor: "applicationDate",
                // @ts-ignore
                Cell: ({ cell: { value } }) => <>{format(parseISO(value), "yyyy-MM-dd")}</>,
            },
            {
                Header: "Action",
                accessor: "action",
            },
        ],
        []
    );

    const tableData: any = useMemo(
        () => trackBenefit,
        [trackBenefit]
    );


    return (
        <div className="transaction-page">
            <PageName pageName={"Benefits"} />
            <div className="transaction">
                <Card className="transaction-card">
                    <div className="h1 text-grayscaleBody border-b pb-4">
                        Track Benefits
                    </div>
                    {/* <div className="flex justify-end mt-10">
                        <a href={RouteNames.INITIATE_BENEFIT} className="btn btn-primary">
                            Initiate Benefit
                        </a>
                    </div> */}

                    {!isLoading && !isSuccess && (
            <div className="flex justify-end mt-10">
              <a href={RouteNames.INITIATE_BENEFIT} className="btn btn-primary">
                Initiate Benefit
              </a>
            </div>
          )}
                    <div className="table-filter-group">
                        <div className="table-filter">
                            <BaseFilter
                                value={filterValue}
                                onChange={(val) => setFilterValue(val)}
                            />
                            <BaseDateRangePicker
                                className="mt-4 sm:mt-0 max-w-full  sm:max-w-[328px] sm:ml-4"
                                onChange={(date) => setDateRangeHandler(date)}
                            />
                            {/*
              <div>
                <button className="btn btn-outline btn-b">Continue</button>
              </div>*/}
                        </div>
                        <div className="table-sort">
                            <button className="btn btn-outline btn-b">
                                Sort
                                <FiChevronDown className="ml-2 " />
                            </button>
                        </div>
                    </div>
                    {!isLoading && isSuccessful ? (
                        tableData?.length ? (
                            <div className="mt-10">
                                {/*@ts-ignore*/}
                                <Table
                                    filterValue={filterValue}
                                    columns={columns}
                                    data={tableData}
                                />
                            </div>
                        ) : (
                            <div className="no-transaction">
                                <div className="no-transaction__text">
                                    Sorry, you do not have any benefit information.
                                </div>
                                <div className="no-transaction__info">
                                    Contact us <a href="mailto:cst@nlpcpfa.com">cst@nlpcpfa.com</a>
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="table-loading">
                            <LoadingSpinner size={"lg"} />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};
export default TrackBenefitPage;
